export default {
	process: [],
	wolfApiProcess: {list:[]},
	selectProcess: {},
	loader: false,
  loaderList: false,
	error: false
}
	
